import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {Dialog, DialogContent} from "@mui/material";
import {FormattedMessage} from "react-intl";


import './InvalidEntryFeePopUp.style.scss';
const InvalidEntryFeePopUp = ({open, onClose, onOk}) => {
    return (
        <Dialog open={open} onClose={onClose} className="InvalidEntryFeePopUp">
            <DialogContent className="InvalidEntryFeeContent">
                <div className={"closeButton"} onClick={onClose}>X</div>
                <Typography className="title">
                    <FormattedMessage id={'popUp.invalidEntryFee.title'}/>
                </Typography>
                <Typography className="subTitle">
                    <FormattedMessage id={'popUp.invalidEntryFee.subTitle'}/>
                </Typography>

                <div className={'actionButton'}>
                    <Button className="retry" onClick={onOk}>
                        <FormattedMessage id={'popUp.invalidEntryFee.tryAgain'}/>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default InvalidEntryFeePopUp;